import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';
import { Tooltip } from '@app-velocity/ui';

const getColor = (value: number) => {
  if (value >= 0.95) return 'linear-gradient(50deg, #4C9842 0%, #5ac12f 100%)';
  if (value >= 0.75) return 'linear-gradient(50deg, #85a637 0%, #c6d330 100%)';
  if (value >= 0.5) return 'linear-gradient(50deg, #DE970B 0%, #FAAD14 100%)';
  if (value >= 0.25) return 'linear-gradient(50deg, #b55a19 0%, #db6836 100%)';
  if (value === 0)
    return 'linear-gradient(50deg,rgb(182, 182, 182) 0%,rgb(226, 226, 226) 100%)';

  return 'linear-gradient(50deg, #b51919 0%, #db3636 100%)';
};

const StyledConfidence = styled('div')<{ value: number }>(
  ({ theme, value }) => ({
    padding: theme.spacing(1),
    marginTop: theme.spacing(2),
    height: theme.spacing(3),
    color: '#fff',
    textAlign: 'center',
    fontSize: 12,
    fontWeight: 600,
    background: getColor(value),
    borderRadius: theme.spacing(1.5),
    width: '100%',
  })
);

export type ScreenConfidenceProps = {
  confidence: string[];
};

export const ScreenConfidence = ({ confidence }: ScreenConfidenceProps) => {
  const { t } = useI18n();

  const getConfidence = (confidence: string[]) => {
    let sum = 0;

    for (const val of confidence) {
      switch (val) {
        case 'high': {
          sum += 1;
          break;
        }

        case 'medium': {
          sum += 0.5;
          break;
        }

        case 'low': {
          sum += 0.05;
          break;
        }
      }
    }

    return Math.round((sum * 100) / confidence.length) / 100;
  };

  const confidenceValue = getConfidence(confidence);

  if (confidence.length === 0)
    return (
      <Tooltip title={t('prototypes:no_confidence')}>
        <StyledConfidence value={0} />
      </Tooltip>
    );

  return (
    <Tooltip
      title={t('prototypes:n_confidence', {
        n: Math.round(confidenceValue * 100),
      })}
    >
      <StyledConfidence value={confidenceValue} />
    </Tooltip>
  );
};
